export const COMPONENT_NAME = "wallet-requisites";
